<template>
  <div class="top-bar">
    <div class="top-header-nav">
        <!-- <Icon type="md-person" /> -->
        <!-- <span style="cursor:pointer">{{username}}</span> -->
        <Dropdown>
          <Badge> <!-- :dot="!!messageUnreadCount" -->
            <Avatar :src="faceimgdate"/>
            {{username}}
          </Badge>
          <Icon :size="18" type="md-arrow-dropdown"></Icon>
          <DropdownMenu slot="list">
            <!-- <DropdownItem name="message">
              消息中心<Badge style="margin-left: 10px" :count="123"></Badge>
            </DropdownItem> -->
            <DropdownItem @click.native="xiugai">修改密码</DropdownItem>
            <DropdownItem @click.native="signOut">退出登录</DropdownItem>
          </DropdownMenu>
        </Dropdown>
    </div>
  </div>
</template>

<script>
  import faceimg from "@/assets/images/face.png";
  export default {
    data () {
      return {
        username: JSON.parse(localStorage.getItem('userInfo')).username,
        faceimgdate: faceimg
      }
    },
    mounted () {
    },
    methods: {
      signOut () {
        localStorage.clear()
        this.$router.push({path:'/login/login'})
      },
      xiugai(){
         this.$router.push({path:'/user/password'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .top-bar {
    position: fixed;
    padding: 0 2%;
    left: 240px;
    top: 0;
    right: 0;
    height: 65px;
    line-height: 65px;
    z-index: 100;
    background: white;
    .top-header-nav {
      float: right;
      height: inherit;
      margin-top: 6px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/layout/TopBar.vue